import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./useSmoothScroll";

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/[0.08] pt-16" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <Logo />
      <nav className="flex flex-wrap items-center gap-6 text-sm text-zinc-400">
        {[["how", "How it works"], ["categories", "Categories"], ["faq", "FAQ"], ["early-access", "Early access"]].map(([id, l]) => (
          <button key={id} onClick={() => scrollToId(id)} data-testid={`footer-link-${id}`} className="hover:text-white transition-colors">{l}</button>
        ))}
        <Link to="/support" data-testid="footer-support-link" className="inline-flex items-center gap-1.5 rounded-full border border-[#FF3838]/50 px-3 py-1 font-medium text-white hover:bg-[#FF3838] hover:text-[#0A0B0E] transition-colors">Help & Support</Link>
        <Link to="/legal/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">Privacy Policy</Link>
      </nav>
    </div>
    <p className="mx-auto max-w-7xl px-5 sm:px-8 mt-10 font-mono text-xs text-zinc-400">© 2026 UrgentSellBuy · urgentsellbuy.com</p>
    <p aria-hidden="true" className="mt-6 select-none whitespace-nowrap text-center font-display font-black leading-[0.8] tracking-tighter text-[17vw] text-outline translate-y-[18%]">
      UrgentSellBuy
    </p>
  </footer>
);
